import I18n from 'helpers/I18n';
import React from 'react';

class AudioPlayer extends React.Component {
  static propTypes = {
    isPlaying: React.PropTypes.bool,
    audioURL:  React.PropTypes.string.isRequired,
    preload:   React.PropTypes.bool,
    onPlay:    React.PropTypes.func,
    onPause:   React.PropTypes.func,
  }

  static defaultProps = {
    preload: true,
    onPlay() {},
    onPause() {},
  }

  state = {
    halfSpeed: false,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isPlaying) {
      if (!this.isPlaying()) {
        this.refs.audio.play();
      }
    } else {
      if (this.isPlaying()) {
        this.refs.audio.pause();
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    this.refs.audio.playbackRate =
      this.refs.audio.defaultPlaybackRate = nextState.halfSpeed ? 0.5 : 1.0;
  }

  componentDidMount() {
    if (this.props.isPlaying) {
      this.refs.audio.play();
    }
  }

  componentWillUnmount() {
    if (this.isPlaying()) {
      this.refs.audio.pause();
    }
  }

  isPlaying() {
    return this.refs.audio.currentTime > 0 && !this.refs.audio.paused && !this.refs.audio.ended && this.refs.audio.readyState > 2;
  }

  handleHalfSpeedChanged = (e) => {
    this.setState({ halfSpeed: e.target.checked });
  }

  render() {
    return (
      <div className="m-tb-5">
        <audio controls ref="audio"
               preload={this.props.preload ? "auto" : "none"}
               onPlay={this.props.onPlay}
               onPause={this.props.onPause}>
          <source src={this.props.audioURL}></source>
        </audio>
        <div className="checkbox m-b-0">
          <label>
            <input type="checkbox" defaultChecked={this.state.halfSpeed} onChange={this.handleHalfSpeedChanged}/>
            {I18n.t("audio_player.half_speed")}
          </label>
        </div>
      </div>
    );
  }
}

export default AudioPlayer;



// WEBPACK FOOTER //
// ./app/javascript/components/application/AudioPlayer.jsx